<template>
  <div
    ref="secContainer"
    class="sec-container"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
    @dragstart="$emit('dragstart', $event)"
    @dragover="$emit('dragover')"
    @dragend="$emit('dragend')"
  >
    <!-- dropable elemet -->
    <div
      v-if="partNum == 0"
      class="dropable dropable-up"
      v-show="showDropEle"
      @dragover.prevent
      @drop="$emit('drop', $event, 'up')"
    ></div>
    <!-- header -->
    <div class="header" :style="{ height: headerHCalc + 'px' }">
      <template v-if="partNum == 0">
        {{ section.book.name }} ({{ $t("mefo.part") }} {{ partNum + 1 }})
        <div>
          <span @click="$emit('pushNext', section)" style="cursor: pointer"
            >⇩</span
          >
          <span @click="$emit('pushBack', section)" style="cursor: pointer"
            >⇧</span
          >
          <span @click="$emit('removeSec', section)" style="cursor: pointer"
            >x</span
          >
        </div>
      </template>
      <template v-else>...</template>
    </div>
    <!-- canvas -->
    <div>
      <canvas class="canvas" ref="canvasPart"></canvas>
    </div>
    <!-- resize-handler -->
    <div
      @mousedown="stratResize"
      :id="'resizeHandler' + section.id"
      class="resize-handler"
      :style="{ height: '100%' }"
    ></div>
    <div
      v-if="partNum == sumParts - 1"
      class="dropable dropable-down"
      v-show="showDropEle"
      @dragstart="$emit('dragstart', $event)"
      @dragover.prevent
      @drop="$emit('drop', $event, 'down')"
    ></div>
  </div>
</template>

<script>
function stratResize(e, ele, onResizeCbk = () => {}) {
  e.preventDefault();
  /**@type {HTMLElement} */
  const element = ele;

  let original_width = getComputedStyle(element, null).getPropertyValue(
    "width"
  );
  let original_height = getComputedStyle(element, null).getPropertyValue(
    "height"
  );
  original_width = Number(original_width.replace("px", ""));
  original_height = Number(original_height.replace("px", ""));

  let original_mouse_x = e.pageX;

  const moveResizeEle = (e) => {
    const width = original_width - (e.pageX - original_mouse_x);
    element.style.width = width + "px";
    const ratio = width / original_width;
    element.style.maxHeight = original_height * ratio + "px";
  };

  const stopResize = (e) => {
    window.removeEventListener("mousemove", moveResizeEle);
    window.removeEventListener("mouseup", stopResize);
    onResizeCbk(e);
  };
  window.addEventListener("mousemove", moveResizeEle);
  window.addEventListener("mouseup", stopResize);
}
export default {
  props: [
    "sumParts",
    "paperW",
    "section",
    "canvases",
    "spaceBottom",
    "partNum",
    "partHeight",
    "basicCanvasWidth",
    "screenRatio",
    "headerHCalc",
    "dropEle",
  ],
  data() {
    return { width: 0 };
  },
  async created() {
    // const vm = this;
    // await new Promise((res, rej) => {
    //   let t = setInterval(() => {
    //     vm.secContainer = vm.$refs.secContainer;
    //     if (vm.secContainer) res(clearInterval(t));
    //   }, 1);
    // });
    // await new Promise((res, rej) => {
    //   let t = setInterval(() => {
    //     vm.canvasPart = vm.$refs.canvasPart;
    //     if (vm.canvasPart) res(clearInterval(t));
    //   }, 1);
    // });
    // this.draw();
  },
  computed: {
    secFinalHeight() {
      // return this.partHeight + this.headerHCalc;
      return this.partHeight + this.headerHCalc;
    },
    showDropEle() {
      return this.dropEle == this.section.id;
    },
  },
  methods: {
    draw() {
      const distCanvas = this.canvasPart;
      const canvases = this.canvases;

      const maxW = Math.max(...canvases.map((c) => c.width));

      const spaceBottom = this.spaceBottom; //space between pharagrphs

      let height = 0;
      for (const cvs of canvases) height += cvs.height + spaceBottom;

      const ctx = distCanvas.getContext("2d");
      distCanvas.width = maxW;
      distCanvas.height = height;

      let y = 0;
      for (const cvs of canvases) {
        ctx.drawImage(cvs, 0, y);
        y += cvs.height + spaceBottom;
      }
    },
    stratResize(e) {
      stratResize(e, this.secContainer, this.onResize);
    },
    onResize() {
      const w = this.secContainer.getBoundingClientRect().width;
      if (w && this.section.width != w) {
        // this.basicCanvasWidth = w / this.parts.length;
        // this.draw();
        this.$emit("setSecWidth", this.section.id, w);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sec-container {
  min-height: 50px;
  position: absolute;
  // top: 15px;
  // left: 15px;
  background-color: rgb(253 251 238 / 45%);
  // resize: horizontal;
  overflow: auto;
  // direction: ltr;
  // float: right;
  padding: 5px;
  overflow: hidden; //temp
  border: 1px solid #80808024;
  // float: right;
}
.sec-container:hover {
  // border: red 2px solid;
  background-color: rgba(128, 128, 128, 0.108);
}
.canvas {
  min-width: 2vw;
  width: 100%;
  //   position: absolute;
  background-color: rgba(255, 255, 255, 0.941);
}
.header {
  display: flex;
  justify-content: space-between;
}
.resize-handler {
  width: 5px;
  height: 100%;
  position: absolute;
  // right: 0px;
  background-color: brown;
  cursor: col-resize;
  z-index: 999;
  opacity: 0;
  left: 0px;
  top: 0px;
}
.resize-handler:hover {
  opacity: 0.5;
}
.dropable {
  background-color: rgba(43, 37, 37, 0.39);
  width: 100%;
  top: 0px;
  height: 12px;
  position: absolute;
  // opacity: 0.2;
  cursor: pointer;
}

.dropable-down {
  top: unset;
  bottom: 0px;
}
</style>
